var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BehaviorSubject, of } from 'rxjs';
import { combineLatest, map, startWith, distinctUntilChanged, debounceTime } from 'rxjs/operators';
import { DataTableSource } from './data-table-souce';
var DEFAULT_PAGE_SIZE = 15;
var DEFAULT_SORT_COLUMN = 'updated_at';
var DEFAULT_SORT_DIRECTION = 'desc';
var PaginatedDataTableSource = /** @class */ (function (_super) {
    __extends(PaginatedDataTableSource, _super);
    /**
     * PaginatedDataTableSource Constructor.
     */
    function PaginatedDataTableSource(config) {
        var _this = _super.call(this, config) || this;
        _this.config = config;
        /**
         * Custom parameters for paginator that can be set by user.
         */
        _this.params = new BehaviorSubject({});
        return _this;
    }
    /**
     * Check if data source does NOT have any results.
     * Will return false if paginator was not initiated yet.
     */
    PaginatedDataTableSource.prototype.isEmpty = function () {
        return this.config.dataPaginator.doesNotHaveResults();
    };
    PaginatedDataTableSource.prototype.loading = function () {
        return this.config.dataPaginator.isLoading;
    };
    /**
     * Set specified params on data source.
     */
    PaginatedDataTableSource.prototype.setParams = function (params) {
        this.params.next(params);
    };
    /**
     * Check if all table rows are selected.
     */
    PaginatedDataTableSource.prototype.allRowsSelected = function () {
        if (!this.config.dataPaginator.data || !this.config.dataPaginator.data.length)
            return false;
        return this.selectedRows.selected.length === this.config.dataPaginator.data.length;
    };
    /**
     * Selects all rows if they are not all selected. Otherwise clear selected rows.
     */
    PaginatedDataTableSource.prototype.masterToggle = function () {
        var _this = this;
        this.allRowsSelected() ?
            this.selectedRows.clear() :
            this.config.dataPaginator.data.forEach(function (row) { return _this.selectedRows.select(row); });
    };
    PaginatedDataTableSource.prototype.refresh = function (params) {
        this.searchQuery.reset();
        this.resetSort();
        this.selectedRows.clear();
        this.config.dataPaginator.refresh(params);
    };
    PaginatedDataTableSource.prototype.init = function (params) {
        var _this = this;
        if (!this.params)
            this.params = new BehaviorSubject({});
        if (params)
            this.params.next(params);
        if (this.config.initialData)
            this.setFilteredData(this.config.initialData);
        this.searchQuery.valueChanges.pipe(debounceTime(400), distinctUntilChanged(), map(function (query) { return { query: query }; })).pipe(combineLatest(this.params, this.params, this.config.matPaginator.page.pipe(startWith(null)), this.getMatSort())).subscribe(function (params) {
            _this.config.dataPaginator.paginate(_this.config.uri, _this.transformParams(params)).subscribe(function (response) {
                _this.config.matPaginator.length = response.data.length ? response.total : 0;
                _this.data.next(response.data);
            });
        });
        this.params.pipe(combineLatest(this.config.matPaginator.page.pipe(startWith(null)), this.getMatSort())).subscribe(function (params) {
            _this.config.dataPaginator.paginate(_this.config.uri, _this.transformParams(params)).subscribe(function (response) {
                _this.config.matPaginator.length = response.data.length ? response.total : 0;
                _this.data.next(response.data);
            });
        });
        return this;
    };
    PaginatedDataTableSource.prototype.getMatSort = function () {
        if (this.config.matSort) {
            return this.config.matSort.sortChange.pipe(startWith(null));
        }
        else {
            return of(null);
        }
    };
    /**
     * Transform combined table parameters (sort, filter, pagination, custom etc) into backend params.
     */
    PaginatedDataTableSource.prototype.transformParams = function (allParams) {
        this.config.dataPaginator.staticQueryParams = this.config.staticParams;
        allParams.push(Object.assign({}, this.config.dataPaginator.staticQueryParams));
        var params = allParams.reduce(function (previous, current) { return Object.assign({}, previous, current); });
        // per page
        params.per_page = params.pageSize || this.config.matPaginator.pageSize || DEFAULT_PAGE_SIZE;
        delete params.pageSize;
        // current page
        params.page = params.pageIndex + 1 || this.config.matPaginator.pageIndex + 1;
        delete params.pageIndex;
        // order by
        var defaultOrder = params.order_by || DEFAULT_SORT_COLUMN;
        params.order_by = (params.active && params.direction) ? params.active : defaultOrder;
        delete params.active;
        // only use direction from mat sort if it was actually changed by user
        var active = this.config.matSort ? this.config.matSort.active : false;
        params.order_dir = (active && params.direction) ? params.direction : DEFAULT_SORT_DIRECTION;
        delete params.direction;
        // search query
        params.query = params.query || this.searchQuery.value;
        if (!params.query)
            delete params.query;
        delete params['length'];
        delete params['previousPageIndex'];
        return params;
    };
    PaginatedDataTableSource.prototype.disconnect = function () {
        this.config.dataPaginator.destroy();
    };
    return PaginatedDataTableSource;
}(DataTableSource));
export { PaginatedDataTableSource };
